"use strict";

module.exports = (x, y) => `translate(${x}, ${y})`;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1ha2VUcmFuc2xhdGUuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsIngiLCJ5Il0sIm1hcHBpbmdzIjoiOztBQUFBQSxNQUFBQSxDQUFPQyxPQUFQRCxHQUFpQixDQUFDRSxDQUFELEVBQUlDLENBQUosS0FBSUEsYUFBbUJELENBQUFBLEtBQU1DLENBQUFBLEdBQTlDSCJ9